export default "__VITE_ASSET__w0wVTI8G__"